import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-textarea",
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-textarea
        [formControl]="formControl"
        [ionKreFormAttributes]="field"
        [rows]="to.rows ? to.rows : 4"
        [maxlength]="to.maxLength || 500"
        [minlength]="to.minLength || 0"
      >
      </ion-textarea>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{ text }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonTextArea extends FieldType {}
